<template>
  <div class="container">
    <div class="header-img">
      <img src="../../assets/images/tunnel/header.png" alt="">
    </div>
    <div class="content">
      <div class="coupon-img">
        <img src="../../assets/images/tunnel/nojuan.png" alt="">
      </div>
      <form action=""  class="custom-form">
        <div class="form-item-blue">
          <van-divider :style="{ color: '#fff', padding: '0 16px' }">注册并领取</van-divider>
        </div>
        <div class="form-item">
          <div class="form-control">
            <input name="phone" type="text" maxlength="11" class="form-input" placeholder="请输入手机号" v-model="phone">
          </div>
        </div>
        <div class="form-item">
          <div class="form-control ">
            <input class="form-input" name="authcode" maxlength="10" type="text" placeholder="请输入验证码" v-model="authcode">
          </div>
          <button class="form-code-btn" :disabled="disabled" @click="sendCode">{{btntxt}}</button>
        </div>
        <div class="form-item form-item-button">
          <button class="form-button" type="submit" @click="formCodeSubmit">立即领取</button>
        </div>
      </form>
      <rule-page></rule-page>
    </div>
  </div>
</template>

<script>
import { Toast, Divider } from 'vant'
import { apiSendCode, apiRegister } from '@/api/user'
import RulePage from './rule'

export default {
  name: 'tunnelregister',
  components: {
    [Divider.name]: Divider,
    RulePage: RulePage
  },
  data () {
    return {
      show: true,
      disabled: false,
      time: 0,
      btntxt: '获取验证码',
      phone: '',
      authcode: ''
    }
  },
  methods: {
    formCodeSubmit (e) {
      e.preventDefault()
      if (!this.phone) {
        Toast({
          message: '手机号不能为空'
        })
        return
      }
      if (!this.checkPhone(this.phone)) {
        Toast({
          message: '手机号格式不正确'
        })
        return
      }
      if (!this.authcode) {
        Toast({
          message: '验证码不能为空'
        })
        return
      }
      let data = {
        phone: this.phone,
        authCode: this.authcode,
        registerType: 22
      }
      if (this.phone === this.invitationCode) {
        Toast({
          message: '自己不能邀请自己'
        })
        return
      }
      apiRegister(data).then((res) => {
        if (res.data.code !== 200) {
          Toast({
            message: res.data.message
          })
        } else if (res.data.code === 200) {
          this.$router.push(`/suctunnel?phone=${this.phone}`)
        }
      })
    },
    checkPhone (phone) {
      let reg = /^1[3456789]\d{9}$/
      if (reg.test(phone)) {
        return true
      } else {
        return false
      }
    },
    timer () {
      if (this.time > 0) {
        this.time--
        this.btntxt = this.time + 's后再获取'
        setTimeout(this.timer, 1000)
      } else {
        this.time = 0
        this.btntxt = '获取验证码'
        this.disabled = false
      }
    },
    sendCode (e) {
      e.preventDefault()
      if (!this.phone) {
        Toast({
          message: '手机号不能为空'
        })
        return
      } else if (!this.checkPhone(this.phone)) {
        Toast({
          message: '手机号格式不正确'
        })
        return
      } else {
        this.time = 60
        this.disabled = true
        this.timer()
      }
      let data = {
        phone: this.phone,
        type: '01'
      }
      apiSendCode(data).then((res) => {
        if (res.data.code === 50003) {
          Toast({
            message: '只有新用户才可领取此优惠！',
            duration: 1500
          })
        } else if (res.data.code !== 200) {
          Toast({
            message: res.data.message,
            duration: 1500
          })
        }
      })
    }
  }
}

</script>
<style lang='scss' scoped>
.container {
  height: 100%;
  background-size: 100%;
  background: #d5ecfe;
}
.header-img {
  img {
    width: 100%;
  }
}
.coupon-img {
  img {
    width: 100%;
  }
}
.content {
  padding: 20px;
  background: url('../../assets/images/tunnel/bg.png');
}
.custom-form {
  margin-bottom: 20px;
  border-radius: 10px;
  background: #fff;
}
.form-item {
  display: flex;
  align-items: center;
  padding:  10px 15px;
  overflow: hidden;
  &:last-child {
    border-bottom: 1px solid  transparent;
  }
}
.form-item.form-item-button {
  padding: 20px 0  10px;
}
.form-item-blue {
  height: 30px;
  line-height: 30px;
  padding: 0 30px;
  margin-bottom: 10px;
  background-image: linear-gradient(0deg, #4e99ff 0%, #00a2ff 100%);
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  /deep/ .van-divider {
    line-height: 30px;
  }
}
.form-title {
  margin: 0 auto;
  font-size: 18px;
  text-align: center;
}
.form-item-rule {
  margin: 0 auto;
  font-size: 15px;
  color: #666;
  text-align: center;
}
.form-control {
  width: 100%;
  background: #f0f0f0;
  padding: 8px 12px;
  border-radius: 5px;
}
.form-control.form-invite {
  font-size: 15px;
}
.form-input {
  width: 100%;
  height: 100%;
  background: #f0f0f0;
  outline: none;
  font-size: 15px;
}
.form-button {
  box-sizing: border-box;
  width: 90%;
  margin: 0 auto;
  padding: 8px 5px;
  font-size: 16px;
  color: #f6660e;
  border-radius: 20px;
  outline: none;
  background-image: linear-gradient(176deg, #fff7c3 1%, #ffbf4a 100%);
}
.form-down {
  position: absolute;
  right: 11%;
  text-align: center;
  background: #fff;
  text-decoration: underline;
  color: #666;
  font-size: 12px;
}

.form-code {
  display: flex;
  align-items: center;
}
.form-code-btn {
  margin-left: 8px;
  padding: 8px 10px;
  height: 100%;
  border-radius: 5px;
  white-space: nowrap;
  font-size: 14px;
  color: #fff;
  line-height: 1;
  outline: none;
  background-image: linear-gradient(0deg, #4e99ff 0%, #00a2ff 100%);
}
.rule-wrapper {
  margin: 20px 0;
  background: #fff;
  border-radius: 10px;
}
.rule-content {
  padding: 0 15px 15px 15px;
  background: #fff;
  border-radius: 10px;
}
.rule-item {
  .title {
    font-size: 14px;
    margin: 15px 0 6px;
    color: #282828;

  }
  .desc {
    line-height: 1.6;
    font-size: 12px;
    color: #999;
  }
}

</style>
